import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import './Styles.css'

const WeekDaySelector = ({onDaysSelection}) => {
    const [selectedDays, setSelectedDays] = useState([]);

    const dayList = [
        {
            id: 1,
            initial: 'M',
            fullname: 'Monday',
            value: 'MON'
        },
        {
            id: 2,
            initial: 'T',
            fullname: 'Tuesday',
            value: 'TUE'
        },
        {
            id: 3,
            initial: 'W',
            fullname: 'Wednesday',
            value: 'WED'
        },
        {
            id: 4,
            initial: 'T',
            fullname: 'Thursday',
            value: 'THU'
        },
        {
            id: 5,
            initial: 'F',
            fullname: 'Friday',
            value: 'FRI'
        },
        {
            id: 6,
            initial: 'S',
            fullname: 'Saturday',
            value: 'SAT'
        },
        {
            id: 7,
            initial: 'S',
            fullname: 'Sunday',
            value: 'SUN'
        },
    ]

    const handleDayChange = (event, newSelectedDays) => {
        setSelectedDays(newSelectedDays);
        onDaysSelection(newSelectedDays)
    };

    return (
        <ToggleButtonGroup
            value={selectedDays}
            onChange={handleDayChange}
            aria-label="days of the week"
            className='weekday-selector-toggle-group'
        >
            {dayList.map(d => (
                <ToggleButton
                    className='weekday-selector-toggle-btn'
                    value={d['value']}
                    title={d['fullname']}
                    aria-label={d['fullname']}>
                    {d['value']}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default WeekDaySelector;
